module.exports = ol.render;